<!-- Non-blocking Premium Splash Screen -->
<app-splash-screen></app-splash-screen>

<!-- Sticky Navigation Header -->
<app-navbar (openWhatsAppModal)="handleOpenWhatsApp()"></app-navbar>

<!-- Main Page Router Content -->
<router-outlet></router-outlet>

<!-- Footer -->
<app-footer (openWhatsAppModal)="handleOpenWhatsApp()"></app-footer>

<!-- Floating WhatsApp Button -->
<app-floating-whatsapp (openWhatsAppModal)="handleOpenWhatsApp()"></app-floating-whatsapp>

<!-- WhatsApp Modal -->
<app-whatsapp-modal [isOpen]="isWhatsAppModalOpen" (close)="handleCloseWhatsApp()"></app-whatsapp-modal>